var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManBeard1E(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "type4_x5F_beards"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x36_",
    d: "M359.9,372.5c3.2,0,9-0.2,12.1-0.1c3.7,0.1,3.9-0.3,4.1,3.2c0.1,2.3,0.2,2.9-0.8,4.2c-2,2.5-5.3,4.7-6.7,5.8 c-0.5,0.4-2.9,2.1-3.5,2.4c3.3,3.4,5.7,8.4,11.7,8.8c5,0.3,9.3,0,13.6-2.4c4.4-2.4,8.6-5.6,13.4-8.9c2.6-1.8,8.7-7.4,10.5-8.8 c2-1.4,8.8-8,10.8-8.8c-6.5,11.2-19.1,25.3-26.2,31.5c-7.4,6.4-20.4,17.2-30.2,17.8c-11.6,0.6-16.3,2.4-26.8-3.2 c-8.7-4.7-17.5-11.9-25.2-18c-9.2-8.1-19.2-18-23.5-27.8c4.8,3.8,13.3,11.6,15.2,12.8c8.2,4.7,11.6,8.2,20.5,12.1 c4.7,2,11.6,4.4,16.8,2.7c2.4-0.8,4.2-2.2,5.9-3.9c0.8-0.8,3.1-3.1,3.4-4.2c0,0-0.4-0.3-2-1.7c-2.6-2.3-7.2-4.6-8.6-7.4 c-0.8-1.7-0.9-4.7,0.4-5.5c0.8-0.5,4.9-0.4,5.9-0.4c2.9-0.1,6.3-0.1,7.3-0.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManBeard1E);
export default __webpack_public_path__ + "static/media/man_beard_1e.cbce993a6ac2ccf28877473a726e1b91.svg";
export { ForwardRef as ReactComponent };